import React, { useState } from "react";
import { Card, Form, Button, ListGroup, Spinner } from "react-bootstrap";
import { useCompanyNotes } from "../../hooks/useCompanyNotes";
import { useAddCompanyNote } from "../../hooks/useAddCompanyNote";
import { useRemoveCompanyNote } from "../../hooks/useRemoveCompanyNote";
import moment from "moment";

const CompanyNotes = ({ companyId, enabled = true }) => {
  const { data: notes, isLoading: notesLoading } = useCompanyNotes(companyId, enabled);
  const { mutate: addNote, isPending: isAddingNote } = useAddCompanyNote();
  const { mutate: removeNote, isPending: isRemovingNote } = useRemoveCompanyNote();
  const [newNote, setNewNote] = useState("");

  const handleAddNote = (e) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    addNote({ companyId, note: newNote.trim() }, {
      onSuccess: () => setNewNote(""),
    });
  };

  const handleRemoveNote = (noteId) => {
    if (window.confirm("Are you sure you want to remove this note?")) {
      removeNote({ companyId, noteId });
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <h5>Admin Notes</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleAddNote} className="mb-3">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Add a note..."
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            className="mb-2"
          />
          <Button type="submit" variant="primary" disabled={isAddingNote || !newNote.trim()}>
            {isAddingNote ? <Spinner size="sm" /> : "Add Note"}
          </Button>
        </Form>

        {notesLoading ? (
          <div className="text-center"><Spinner /></div>
        ) : notes?.length > 0 ? (
          <ListGroup>
            {notes.map((note) => (
              <ListGroup.Item key={note._id} className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <p className="mb-1">{note.note}</p>
                  <small className="text-muted">
                    {note.createdBy?.name || "Admin"} - {moment(note.createdAt).format("MMM DD, YYYY h:mm A")}
                  </small>
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveNote(note._id)}
                  disabled={isRemovingNote}
                >
                  Remove
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p className="text-muted">No notes yet.</p>
        )}
      </Card.Body>
    </Card>
  );
};

export default CompanyNotes;

